import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "light-text" }
const _hoisted_2 = { class: "flex column align-c full-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "header" }, "Experience", -1)
const _hoisted_4 = { class: "subHeader" }
const _hoisted_5 = { class: "subheader" }
const _hoisted_6 = ["src", "onClick"]
const _hoisted_7 = { class: "responsive-text-medium" }
const _hoisted_8 = { class: "flex column align-c" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", null, "Takeaways", -1)
const _hoisted_10 = { class: "subHeader" }
const _hoisted_11 = { class: "padded-container-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", { class: "text-align-c" }, "Education", -1)
const _hoisted_13 = { class: "w-fit m-center flex align-c" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "University of Tennessee at Chattanooga"),
  /*#__PURE__*/_createElementVNode("p", null, "BA, Communication 2013")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex between align-c", _ctx.$style.experiencePageHeader])
      }, [
        _hoisted_3,
        _createElementVNode("a", {
          class: "btn-action",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDownloadResume && _ctx.handleDownloadResume(...args)))
        }, "Download CV")
      ], 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.experienceList, (experience) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(_ctx.$style.experienceListItem),
          key: experience.employer,
          ref_for: true,
          ref: experience.employer
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.$style.experienceItemHeader, "bottom-header-border align-e between m-b-1"])
          }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(experience.position), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(experience.ext.image ? '' : experience.employer), 1),
            (experience.ext.image)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: _normalizeClass(_ctx.$style.extImage),
                  src: experience.ext.image,
                  onClick: ($event: any) => {_ctx.handleNavigateToExternalLink(experience.ext.link);}
                }, null, 10, _hoisted_6))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", null, _toDisplayString(experience.date), 1),
          _createElementVNode("p", null, _toDisplayString(experience.description), 1),
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(experience.notes, (note) => {
              return (_openBlock(), _createElementBlock("li", { key: note }, _toDisplayString(note), 1))
            }), 128))
          ])
        ], 2))
      }), 128))
    ]),
    _createElementVNode("section", _hoisted_8, [
      _hoisted_9,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.takeawayList, (item) => {
        return (_openBlock(), _createElementBlock("ul", {
          class: _normalizeClass(["m-none", _ctx.$style.experienceListItem]),
          key: item.title
        }, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(item.title), 1),
          _createElementVNode("p", null, _toDisplayString(item.detail), 1)
        ], 2))
      }), 128))
    ]),
    _createElementVNode("section", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("img", {
          style: { height: '5em', marginRight: '2em', cursor: 'pointer' },
          src: "https://upload.wikimedia.org/wikipedia/commons/d/df/University_of_Tennessee_at_Chattanooga_athletics_logo.png",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleNavigateToExternalLink('https://www.utc.edu/')))
        }),
        _hoisted_14
      ])
    ])
  ]))
}